import React, { useState, useEffect } from 'react';
import logo from "../assets/logo.png";
import book from "../assets/book.svg";
import twitter from "../assets/twitter.svg";
import telegram from "../assets/telegram.svg";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";

export function Navbar() {
  const [isMenuHidden, setIsMenuHidden] = useState(true);

  const navigationItems = [
    {
      text: "Home",
      className: "text-white font-bold",
      href: "/",
    },
    {
      text: "Token",
      className: "text-white hover:font-bold",
      href: "/",
    },
    {
      text: "Refferal",
      className: "text-white hover:font-bold",
      href: "/",
    },
    {
      text: "Roadmap",
      className: "text-white hover:font-bold",
      href: "/",
    },
    {
      text: "Register",
      className: "text-white hover:font-bold",
      href: "/",
    },
    {
      text: "FAQ",
      className: "text-white hover:font-bold",
      href: "/",
    },
  ];

  const handleMenuToggle = () => {
    setIsMenuHidden((prev) => !prev);
  };

  useEffect(() => {
    // Add event listeners
    const backdrop = document.querySelectorAll(".navbar-backdrop");

    backdrop.forEach((item) =>
      item.addEventListener("click", handleMenuToggle)
    );

    // Clean up event listeners on component unmount
    return () => {
      backdrop.forEach((item) =>
        item.removeEventListener("click", handleMenuToggle)
      );
    };
  }, []);

  return (
    <>
      <nav className="relative md:px-24 px-10 flex justify-between items-center">
        <a className="text-3xl font-bold leading-none" href="/">
          <img src={logo} alt='flappybird' className='md:h-24 md:w-24 h-14 w-14'/>
        </a>
        <div className="lg:hidden">
          <button
            className="flex items-center text-purple-600 p-3"
            onClick={handleMenuToggle}
          >
            <AiOutlineMenu />
          </button>
        </div>
        <ul
          className={`hidden absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 lg:mx-auto lg:flex lg:items-center lg:w-auto lg:space-x-6`}
        >
          {navigationItems.map((item, index) => (
            <React.Fragment key={index}>
              <li>
                <a className={item.className} href={item.href}>
                  {item.text}
                </a>
              </li>
              {index < navigationItems.length - 1 && (
                <li className="text-gray-300">
                </li>
              )}
            </React.Fragment>
          ))}
        </ul>
        <div className='md:flex hidden'>
        <a className="" href="/" >
          <img className='h-8 w-8' src={book} alt=''/>
        </a>
        <a className="" href="/" >
          <img className='h-8 w-8 mx-3' src={telegram} alt=''/>
        </a>
        <a className="" href="/" >
          <img className='h-8 w-8' src={twitter} alt=''/>
        </a>
        </div>
      </nav>
      <div
        className={`navbar-menu relative z-50 ${
          isMenuHidden
            ? "opacity-0 pointer-events-none"
            : "opacity-100 pointer-events-auto"
        } transition-opacity duration-300 ease-in-out`}
      >
        <div className="navbar-backdrop fixed inset-0 bg-gray-800 opacity-25"></div>
        <nav className="fixed top-0 left-0 bottom-0 flex flex-col w-5/6 max-w-sm py-6 px-6 bg-purple-800 border-r overflow-y-auto">
          <div className="flex items-center mb-8">
            <a className="mr-auto text-3xl font-bold leading-none" href="/">
            <img src={logo} alt='flappybird' className='h-10 w-10'/>
            </a>
            <button className="navbar-close" onClick={handleMenuToggle}>
              <AiOutlineClose />
            </button>
          </div>
          <div>
            <ul>
              {navigationItems.map((item, index) => (
                <React.Fragment key={index}>
                  <li className="mb-1">
                    <a
                      className="block p-4 text-sm font-semibold text-white hover:bg-purple-50 hover:text-purple-600 rounded"
                      href="/"
                    >
                      {item.text}
                    </a>
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </div>
          <div className="mt-auto">
          <div className='flex items-center justify-center md:hidden'>
        <a className="" href="/" >
          <img className='h-8 w-8' src={book} alt=''/>
        </a>
        <a className="" href="/" >
          <img className='h-8 w-8 mx-3' src={telegram} alt=''/>
        </a>
        <a className="" href="/" >
          <img className='h-8 w-8' src={twitter} alt=''/>
        </a>
        </div>
            <p className="my-4 text-xs text-center text-gray-400">
              <span>Copyright flappybird © 2024</span>
            </p>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Navbar;

